import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '12px 16px',
    ...theme.mixins.toolbar
  },
  appBarSpacer: theme.mixins.toolbar,
  drawerPaper: {
    position: 'relative',
    width: 'fit-content',
    height: '100vh',
    maxHeight: '100%',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    }),
    padding: '0.625rem',
    backgroundColor: '#000'
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    width: 0
  },
  nested: {
    marginLeft: theme.spacing(6),
    borderRadius: '0.5rem',
    width: '77%',
    height: '2.5rem',
    padding: '0.75rem 0.5rem',
    '&:hover': {
      backgroundColor: theme.palette.action.selected,
      borderRadius: '0.5rem',
      width: '77%',
      height: '2.5rem'
    }
  },
  logo: {
    maxWidth: '80%',
    width: 'auto',
    height: '2rem',
    fill: '#ffffff',
    cursor: 'pointer'
  },
  mainSidebar: {
    // maxHeight: `calc(50%)`,
    // [theme.breakpoints.down('sm')]: {
    //   maxHeight: `calc(100% - 300px)`
    // }
    // '&>div': {
    //   overflowX: 'hidden !important'
    // }
  },
  bottomSidebar: {
    width: '100%'
  },
  listItem: {
    fontSize: '1rem !important'
  },
  listItemText: {
    fontSize: '1rem'
  },
  listItemIcon: {
    minWidth: '1rem',
    marginRight: '1rem',
    color: '#9e9e9e'
  },
  activeIcon: {
    color: '#ffffff',
    opacity: 1
  },
  globalMessagesSpacing: {
    marginTop: '4.5rem'
  },
  sidebarContainer: {
    backgroundColor: '#1B1B1B',
    borderRadius: '0.75rem',
    padding: '0.75rem',
    width: '20rem',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '92vh',
    overflow: 'scroll'
  },
  selectedItem: {
    backgroundColor: '#363636',
    borderRadius: '0.75rem',
    paddingBottom: '0.75rem'
  },
  openDropdown: {
    backgroundColor: theme.palette.action.selected,
    padding: '0.75rem 0rem',
    height: '2.5rem',
    borderRadius: '0.5rem',
    width: '77%'
  },
  noHorizontalPadding: {
    paddingLeft: '0.75rem',
    paddingRight: '0.75rem',
    borderRadius: '0.5rem'
  },
  logoutButton: {
    marginTop: '2rem'
  }
}));

export default useStyles;
